import instance from '@src/api/common';

export * from './queryHooks';

export const requestEventRemainCount = () => {
  return instance.get(`/v1/mapped_events/remain_count`);
};
